import { AlertTriangle, ArrowLeft, Shield } from 'lucide-react'
import styles from './BridgeEntryPage.module.css'

export default function BridgeEntryPage({ error }) {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.icon}><AlertTriangle size={40} /></div>
        <h1 className={styles.title}>Session Error</h1>
        <p className={styles.message}>
          {error || 'Unable to validate your session from PatientTracForge.'}
        </p>
        <div className={styles.details}>
          <p>This may happen if:</p>
          <ul>
            <li>The session token has expired (tokens expire after 4 hours)</li>
            <li>You navigated directly to this URL without a valid session</li>
            <li>The PatientTracForge server is temporarily unavailable</li>
          </ul>
        </div>
        <a href="https://patienttracforge.com/schedule" className={styles.returnBtn}>
          <ArrowLeft size={16} /> Return to PatientTracForge
        </a>
        <div className={styles.hipaa}>
          <Shield size={12} />
          All session data is encrypted · HIPAA 45 CFR §164
        </div>
      </div>
    </div>
  )
}
